import React, { useCallback, useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import TimesheetsSidebar from "./components/navigation/TimesheetsSidebar";
import Header from "./components/library/Header";
import Container from "./components/library/Container";
import Team from "./views/Team";
import Timesheets from "./views/Timesheets";
import { Navbar } from "./components/library/Navbar";
import { Breadcrumb, BreadcrumbItem } from "./components/library/Breadcrumb";
import Zendesk from "./components/library/Zendesk";

import "./App.css";

function App() {
  const [requiredMinutes, setRequiredMinutes] = useState(450);
  const [isLineManager, setIsLineManager] = useState(false);
  const [searchParams, setSearchParams] = useState(null);

  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!search) return;

    const newSearchParams = new URLSearchParams(search);

    setSearchParams(newSearchParams);
  }, [search]);

  const fetchUser = useCallback(() => {
    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/identify`, {
      headers: {
        "x-access-token": localStorage.getItem("access_token"),
      },
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error(await res.text());
      })
      .then((response) => {
        if (!isNaN(response.timesheetsRequiredDailyHours)) {
          setRequiredMinutes(response.timesheetsRequiredDailyHours * 60);
        }
        setIsLineManager(response.isLineManager);
      })
      .catch((error) => {
        console.error(error);
        window.location = `${process.env.REACT_APP_AUTH_ENDPOINT}/logout/${process.env.REACT_APP_JWT_CLIENT_ID}`;
      });
  }, []);

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="App">
      <Navbar>
        <Breadcrumb>
          <BreadcrumbItem href="https://native.feed.xyz">
            Dashboard
          </BreadcrumbItem>
          <BreadcrumbItem href="/">Timesheets</BreadcrumbItem>
          {(pathname === "/team" || pathname.includes("users")) && (
            <BreadcrumbItem href="/team">My Team</BreadcrumbItem>
          )}
          {pathname.includes("users") && searchParams && (
            <BreadcrumbItem href="#">{searchParams.get("name")}</BreadcrumbItem>
          )}
        </Breadcrumb>
        <Zendesk />
      </Navbar>
      <TimesheetsSidebar isLineManager={isLineManager} />
      <Switch>
        <Route path="/team">
          <Container>
            <Header title="My Team" />
          </Container>
          <Team />
        </Route>
        <Route path="/users/:userId">
          {searchParams && (
            <>
              <Container>
                <Header title={searchParams.get("name")} />
              </Container>
              <Timesheets
                initialDate={searchParams.get("date")}
                requiredMinutes={searchParams.get("requiredMinutes") * 60}
                name={searchParams.get("name")}
              />
            </>
          )}
        </Route>
        <Route>
          <Container>
            <Header title="Timesheets" />
          </Container>
          <Timesheets requiredMinutes={requiredMinutes} />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
